import { ValidationFunctionResult } from '../../types/validation-function-result';
import { phoneSchema } from '../schemas/phone.schema';

/**
 * Validates if a phone number is valid.
 * @param phone - The phone number to validate.
 * @param abortEarly - Whether to abort the validation on the first error.
 * @returns The validation result.
 */
export const isValidPhone = (
	phone: string,
	abortEarly: boolean = false,
): ValidationFunctionResult => {
	// Validate
	const { error } = phoneSchema().validate(phone, {
		abortEarly,
	});

	// Check
	if (error) {
		return {
			isValid: false,
			errors: error.details?.map((e) => e.message),
		};
	}

	// Return
	return { isValid: true };
};
